import type { MergedTheme, BaseThemeColors } from '@owner/theme'
import type { HexColor } from '@owner/theme'

/**
 * Absolute neutral colors that don't change with light/dark themes
 */
export interface AbsoluteNeutralColors {
  white: HexColor // neutral.100 - #FFFFFF
  lightGray: HexColor // neutral.300 - #EBEBEC
  black: HexColor // neutral.900 - #0D0D0D
}

/**
 * Extended theme interface that includes absolute neutral colors
 * alongside the standard theme-aware colors
 */
export interface ExtendedMergedTheme extends MergedTheme {
  absolute: {
    neutral: AbsoluteNeutralColors
  }
}

/**
 * Extracts absolute neutral colors from base theme colors
 * These values remain constant regardless of light/dark theme setting
 * @param baseThemeColors
 */
export const extractAbsoluteNeutralColors = (
  baseThemeColors: BaseThemeColors
): AbsoluteNeutralColors => {
  const { neutral } = baseThemeColors.palettes

  return {
    black: neutral[900],
    lightGray: neutral[300],
    white: neutral[100],
  }
}
